import React from 'react'
import type { CategoryCount } from '../../types'

interface CategoryFilterProps {
  categories: CategoryCount[]
  selectedCategory?: string
  onSelect: (category: string | undefined) => void
}

export const CategoryFilter: React.FC<CategoryFilterProps> = ({
  categories,
  selectedCategory,
  onSelect,
}) => {
  if (categories.length === 0) return null

  return (
    <>
      <style>{`
        .category-filter {
          display: flex;
          gap: 8px;
          overflow-x: auto;
          padding: 4px 0 8px;
          scrollbar-width: thin;
          scrollbar-color: var(--border-color) transparent;
        }
        .category-filter::-webkit-scrollbar {
          height: 4px;
        }
        .category-filter::-webkit-scrollbar-thumb {
          background: var(--border-color);
          border-radius: 2px;
        }
        .category-pill {
          flex-shrink: 0;
          padding: 5px 14px;
          border-radius: 3px;
          border: 1px solid var(--border-color);
          background-color: var(--bg-secondary);
          color: var(--text-secondary);
          font-family: 'JetBrains Mono', 'Courier New', monospace;
          font-size: 0.78rem;
          cursor: pointer;
          transition: all 0.15s ease;
          white-space: nowrap;
        }
        .category-pill:hover {
          border-color: var(--accent-green);
          color: var(--accent-green);
        }
        .category-pill.active {
          background-color: var(--accent-green);
          border-color: var(--accent-green);
          color: #000;
          font-weight: 700;
        }
        .category-pill:focus-visible {
          outline: 2px solid var(--accent-cyan);
          outline-offset: 2px;
        }
        .category-count {
          opacity: 0.65;
          margin-left: 4px;
          font-size: 0.72rem;
        }
      `}</style>
      <div className="category-filter" role="group" aria-label="Filter by category">
        <button
          className={`category-pill${!selectedCategory ? ' active' : ''}`}
          onClick={() => onSelect(undefined)}
          aria-pressed={!selectedCategory}
        >
          All
        </button>
        {categories.map((cat) => (
          <button
            key={cat.category}
            className={`category-pill${selectedCategory === cat.category ? ' active' : ''}`}
            onClick={() => onSelect(cat.category)}
            aria-pressed={selectedCategory === cat.category}
          >
            {cat.category}
            <span className="category-count">({cat.count})</span>
          </button>
        ))}
      </div>
    </>
  )
}
